const initialState = {
  network_activity: [],
  overview: {},
  backlinks: {},
  referring_domains: {},
  top_anchors: {},
  tld_distribution: {},
  top_countries: {},
  overview_settings: [
    {
      key: "domain_score",
      title: "Domain Score",
      tooltip:
        "This metric is measuring the importance of the domain based on the volume and quality of links that are pointing to it. The score is on a scale from 0 to 100, with 100 meaning the domain is highly important and its links communicate a strong amount of popularity."
    },
    {
      key: "total_backlinks",
      title: "Total Backlinks",
      tooltip: "Total number of incoming links to your domain."
    },
    {
      key: "referring_domains",
      title: "Referring Domains",
      tooltip: "The number of domains that are linking back to your domain."
    },
    {
      key: "follow_links",
      title: "Follow Links",
      tooltip:
        "Follow links are links that instruct search crawlers to follow and therefore boost the SEO of the linked-to site by communicating trust and impacting organic rankings."
    },
    {
      key: "nofollow_links",
      title: "Nofollow Links",
      tooltip:
        "A Nofollow link is a link that will send users to another site if clicked on, but tells search bots not to crawl, therefore conveying less of a trust signal that would help the SEO of the linked-to site. Nofollow attributes are commonly applied by webmasters on any paid links, user-generated content, or in comments sections of websites."
    }
  ],
  tabs_settings: [
    {
      label: "Most recently found",
      resource_type: "backlinks",
      order_by: "first_seen",
      order_dir: "desc"
    },
    {
      label: "Most important",
      resource_type: "backlinks",
      order_by: "page_score",
      order_dir: "desc"
    },
    {
      label: "Referring domains",
      resource_type: "referring_domains",
      order_by: "backlinks_num",
      order_dir: "desc"
    },
    {
      label: "Top anchors",
      resource_type: "top_anchors",
      order_by: "domains_num",
      order_dir: "desc"
    },
    {
      label: "TLD distribution",
      resource_type: "tld_distribution",
      order_by: "domains_num",
      order_dir: "desc"
    },
    {
      label: "Top countries",
      resource_type: "top_countries",
      order_by: "domains_num",
      order_dir: "desc"
    }
  ]
};

export default initialState;
